import manualWheelchairImg from "../assets/images/manual-wheelchair.png";
import walkingCaneImg from "../assets/images/3-leg-walking-cane.png";
import electricHospitalBedImg from "../assets/images/electric-hospital-bed.png";
import electricWheelchairImg from "../assets/images/electric-wheelchair.png";
import showerCommodeImg from "../assets/images/shower-commode-chair.png";
import bpMonitorImg from "../assets/images/bp-monitor.png";
import cgmSystemImg from "../assets/images/cgm-system.png";
import glucometerImg from "../assets/images/glucometer.png";
import bluetoothHearingAidImg from "../assets/images/bluetooth-hearing-aid.png";
import neckbandHearingAidImg from "../assets/images/neckband-hearing-aid.png";
import pulseOximeterImg from "../assets/images/pulse-oximeter.png";
import meshNebulizerImg from "../assets/images/mesh-nebulizer.png";
import compressNebulizerImg from "../assets/images/compress-nebulizer.png";
import digitalThermometerImg from "../assets/images/digital-thermometer.png";
import cpapMachineImg from "../assets/images/cpap-machine.png";
import oxygenConcentratorImg from "../assets/images/oxygen-concentrator.png";
import medicationDispenserImg from "../assets/images/medication-dispenser.png";
import drAsthaGhimireImg from "../assets/images/dr-astha-ghimire.png";
import erAshokPaudelImg from "../assets/images/er-ashok-paudel.png";

export const categories = [
  { id: "premium", label: "Premium Collection" },
  { id: "midrange", label: "Mid-Range" },
  { id: "mobility", label: "Mobility" },
  { id: "monitoring", label: "Monitoring" },
];

export const needCategories = [
  { id: "elderly", label: "Elderly", tagline: "General everyday comfort" },
  { id: "diabetes", label: "Diabetes", tagline: "Track glucose with confidence" },
  { id: "hearing", label: "Hearing", tagline: "Clear sound for daily life" },
  { id: "homecare", label: "Home care", tagline: "Care at home, made simple" },
];

const elderlyNeedProducts = [
    {
      id: 101,
      name: "Manual Transport Wheelchair",
      subtitle: "Lightweight Foldable",
      category: "mobility",
      needCategory: "elderly",
      subCategory: "manual-wheelchair",
      tag: "MOBILITY",
      description: "Lightweight aluminum transport wheelchair for caregivers and daily mobility. Foldable frame, padded mesh seating, and hand brakes for safe, comfortable transfers.",
      features: [
        "Foldable aluminum frame",
        "Padded mesh seat & backrest",
        "Flip-up armrests",
        "Caregiver hand brakes",
        "Integrated seatbelt",
      ],
      color: "#e8e8e8",
      accent: "#6b7280",
      image: manualWheelchairImg,
    },
    {
      id: 102,
      name: "Electric Wheelchair",
      subtitle: "Pro Series",
      category: "premium",
      needCategory: "elderly",
      subCategory: "electric-wheelchair",
      tag: "BESTSELLER",
      description: "Precision-engineered electric mobility for independence and dignity. Whisper-quiet motor, ergonomic seating, long-range battery.",
      features: [
        "12-hour battery life",
        "Foldable frame",
        "Smart joystick control",
        "USB charging port",
      ],
      color: "#1a1a2e",
      accent: "#1f4d3d",
      image: electricWheelchairImg,
    },
    {
      id: 103,
      name: "Shower Commode Chair",
      subtitle: "Mobile Toilet & Shower Seat",
      category: "mobility",
      needCategory: "elderly",
      subCategory: "shower-commode",
      tag: "SAFETY",
      description: "Water-resistant aluminum commode and shower chair in one. Removable bucket, padded armrests, and swivel wheels for safe bedside and bathroom use.",
      features: [
        "Shower-safe aluminum frame",
        "Removable commode bucket",
        "Padded armrests",
        "Height-adjustable legs",
        "Swivel caster wheels",
      ],
      color: "#f5f5f5",
      accent: "#5b8a72",
      image: showerCommodeImg,
    },
    {
      id: 104,
      name: "BP Monitor",
      subtitle: "Upper Arm Digital",
      category: "monitoring",
      needCategory: "elderly",
      subCategory: "bp-monitor",
      tag: "ESSENTIAL",
      description: "Hospital-grade upper arm blood pressure monitor for home use. Large LCD display, WHO classification bar, and memory for daily tracking.",
      features: [
        "Large LCD display",
        "WHO classification indicator",
        "Pulse rate measurement",
        "22–32 cm arm cuff",
        "Memory for 2 users",
      ],
      color: "#f8f8f8",
      accent: "#3d6b58",
      image: bpMonitorImg,
    },
    {
      id: 105,
      name: "3 Leg Walking Cane",
      subtitle: "Folding Seat Cane",
      category: "mobility",
      needCategory: "elderly",
      subCategory: "3-leg-walking-cane",
      tag: "MOBILITY",
      description: "Multifunction walking cane that unfolds into a stable three-legged seat. Ergonomic handle, padded seat, and non-slip rubber tips for safe walking and resting on the go.",
      features: [
        "Converts from cane to tripod seat",
        "Stable three-leg support frame",
        "Ergonomic T-handle grip",
        "Padded fold-down seat",
        "Non-slip rubber ferrules",
        "Lightweight aluminum construction",
      ],
      color: "#ffffff",
      accent: "#78716c",
      image: walkingCaneImg,
    },
    {
      id: 106,
      name: "Electric Hospital Bed",
      subtitle: "Full Electric Adjustable",
      category: "premium",
      needCategory: "elderly",
      subCategory: "electric-hospital-bed",
      tag: "SPECIALIST",
      description:
        "Full-electric adjustable hospital bed for home recovery. Four-motor positioning, safety side rails, and lockable caster wheels for safe, comfortable care at home.",
      features: [
        "4-motor electric height & incline adjustment",
        "Full-length safety side rails",
        "Lockable medical-grade caster wheels",
        "Foot-pedal & side panel controls",
        "Trendelenburg & reverse positioning",
        "Ideal for elderly home care",
      ],
      color: "#f8fafc",
      accent: "#5b9bd5",
      image: electricHospitalBedImg,
    },
    {
      id: 107,
      name: "Tranquil GPS Watch",
      subtitle: "Dementia Care — AngelSense",
      category: "premium",
      needCategory: "elderly",
      subCategory: "gps-watch",
      tag: "CARE+",
      description:
        "GPS tracking wristband with fall detection for elderly and dementia care. Two-way calling, geo-fence alerts, and real-time location for family peace of mind.",
      features: [
        "Real-time GPS tracking",
        "Fall detection alerts",
        "Geo-fence notifications",
        "Two-way calling",
        "Comfortable wristband wear",
        "Caregiver smartphone sync",
      ],
      color: "#2d1b69",
      accent: "#e040fb",
      imageType: "watch",
    },
];

const diabetesNeedProducts = [
  {
    id: 201,
    name: "CGM",
    subtitle: "Continuous Glucose Monitor",
    category: "premium",
    needCategory: "diabetes",
    subCategory: "cgm",
    tag: "NEW",
    description: "Wearable continuous glucose monitoring with Bluetooth sync to your smartphone. Real-time interstitial fluid readings, trend analytics, and hypo/hyper alerts without routine finger pricks.",
    features: [
      "Real-time interstitial glucose monitoring",
      "Bluetooth Low Energy (BLE) smartphone sync",
      "14-day extended-wear waterproof sensor",
      "Time-in-range & glycemic trend analytics",
      "One-click automated sensor applicator",
      "Customizable hypo/hyperglycemic alerts",
    ],
    color: "#f5f5f5",
    accent: "#2d8b7a",
    image: cgmSystemImg,
  },
  {
    id: 202,
    name: "Glucometer",
    subtitle: "Digital Blood Glucose Meter",
    category: "monitoring",
    needCategory: "diabetes",
    subCategory: "glucometer",
    tag: "ESSENTIAL",
    description: "Compact digital blood glucose meter for precise at-home testing. Large high-contrast LCD, rapid micro-sample technology, and onboard memory for daily glucose tracking.",
    features: [
      "Large high-contrast LCD display",
      "Rapid result technology (seconds)",
      "Micro-sample blood requirement",
      "Internal memory for trend review",
      "Automatic test strip recognition",
      "One-touch M-button operation",
    ],
    color: "#ffffff",
    accent: "#4a6fa5",
    image: glucometerImg,
  },
];

const hearingNeedProducts = [
  {
    id: 301,
    name: "Bluetooth Hearing Aid",
    subtitle: "Rechargeable In-Ear with Case",
    category: "premium",
    needCategory: "hearing",
    subCategory: "bluetooth-hearing-aid",
    tag: "PREMIUM",
    description: "Discreet true wireless hearing aids with a portable charging case. Bluetooth streaming, digital noise processing, and all-day battery with LED charge indicators.",
    features: [
      "True wireless in-ear design",
      "Bluetooth audio streaming",
      "Magnetic charging case with LED status",
      "AI digital noise reduction",
      "Left/right marked earpieces",
      "Rechargeable lithium battery",
    ],
    color: "#f5f5f5",
    accent: "#1f4d3d",
    image: bluetoothHearingAidImg,
  },
  {
    id: 302,
    name: "Neck Band Hearing Aid",
    subtitle: "Wireless Neckband Style",
    category: "midrange",
    needCategory: "hearing",
    subCategory: "neckband-hearing-aid",
    tag: "COMFORT",
    description: "Lightweight neckband hearing amplifier with secure-fit ear tips. Ergonomic around-the-neck design with tactile controls and magnetic quick-charge contacts.",
    features: [
      "Flexible ergonomic neckband",
      "Secure-fit silicone ear tips",
      "Magnetic quick-charge contacts",
      "Integrated volume & mode controls",
      "Wireless Bluetooth connectivity",
      "All-day lightweight wear",
    ],
    color: "#1a1a1a",
    accent: "#4a5568",
    image: neckbandHearingAidImg,
  },
];

const homecareNeedProducts = [
  {
    id: 401,
    name: "Pulse Oximeter",
    subtitle: "Fingertip SpO2 Monitor",
    category: "monitoring",
    needCategory: "homecare",
    subCategory: "pulse-oximeter",
    tag: "ESSENTIAL",
    description: "Clip-on fingertip pulse oximeter for instant SpO2 and pulse rate readings. Bright LED display with one-button operation for home and travel monitoring.",
    features: [
      "SpO2 & pulse rate (BPM) display",
      "Bright red LED readout",
      "One-button fingertip operation",
      "Low battery indicator",
      "Portable clip-on design",
      "Auto power-off",
    ],
    color: "#f0f4f8",
    accent: "#2563eb",
    image: pulseOximeterImg,
  },
  {
    id: 402,
    name: "Mesh Nebulizer",
    subtitle: "Handheld Portable",
    category: "monitoring",
    needCategory: "homecare",
    subCategory: "mesh-nebulizer",
    tag: "ESSENTIAL",
    description: "Ultra-portable mesh nebulizer with intelligent LED interface. Vibrating mesh atomization delivers fine particles for effective respiratory therapy at home.",
    features: [
      "Vibrating mesh atomization",
      "Handheld portable design",
      "LED timer & status display",
      "Low-liquid & battery alerts",
      "Silent operation technology",
      "Includes face mask attachment",
    ],
    color: "#f5f5f5",
    accent: "#64748b",
    image: meshNebulizerImg,
  },
  {
    id: 403,
    name: "Compress Nebulizer",
    subtitle: "Compressor System",
    category: "monitoring",
    needCategory: "homecare",
    subCategory: "compress-nebulizer",
    tag: "CLINICAL",
    description: "Home compressor nebulizer with adjustable mist control and integrated medication cup. Reliable piston compression for consistent aerosol delivery.",
    features: [
      "Adjustable mist control dial",
      "Integrated medication chamber",
      "Side ventilation cooling system",
      "Rocker power switch",
      "Mouthpiece included",
      "Compact home-use design",
    ],
    color: "#fff7ed",
    accent: "#ea580c",
    image: compressNebulizerImg,
  },
  {
    id: 404,
    name: "Digital Thermometer",
    subtitle: "Non-Contact Infrared",
    category: "monitoring",
    needCategory: "homecare",
    subCategory: "digital-thermometer",
    tag: "ESSENTIAL",
    description: "Non-contact infrared thermometer for hygienic body temperature checks. Green backlit LCD with memory recall and fever alarm indicators.",
    features: [
      "Non-contact infrared sensor",
      "Instant digital readout",
      "Green backlit LCD display",
      "Body & object temperature modes",
      "Memory recall function",
      "Mute mode for quiet use",
    ],
    color: "#ffffff",
    accent: "#16a34a",
    image: digitalThermometerImg,
  },
  {
    id: 405,
    name: "CPAP Machine",
    subtitle: "Complete Sleep Therapy Kit",
    category: "premium",
    needCategory: "homecare",
    subCategory: "cpap-machine",
    tag: "CLINICAL",
    description: "Full CPAP package with humidifier, mask, tubing, and manual. Auto-adjusting pressure therapy for obstructive sleep apnea with integrated heated humidification.",
    features: [
      "Auto-adjusting pressure therapy",
      "Integrated heated humidifier",
      "Full-face mask & headgear included",
      "Flexible air tubing",
      "LCD display with control dial",
      "Complete home therapy package",
    ],
    color: "#f8fafc",
    accent: "#66c0f4",
    image: cpapMachineImg,
  },
  {
    id: 406,
    name: "Oxygen Concentrator",
    subtitle: "Home Oxygen Therapy",
    category: "premium",
    needCategory: "homecare",
    subCategory: "oxygen-concentrator",
    tag: "CLINICAL",
    description: "Compact home oxygen concentrator with intelligent LED monitoring. Adjustable flow settings and touch-control interface for continuous respiratory support.",
    features: [
      "Adjustable oxygen flow control",
      "Real-time LED status display",
      "Touch-control operation panel",
      "Compact home-care footprint",
      "Low-noise compressor technology",
      "Continuous oxygen delivery",
    ],
    color: "#f5f5f5",
    accent: "#374151",
    image: oxygenConcentratorImg,
  },
];

export const visitReasonCategories = [
  {
    id: "hospital",
    label: "Just came home from hospital",
    tagline: "Beds, wheelchairs, commode chairs & vital monitoring kits",
    tone: "sage",
  },
  {
    id: "family",
    label: "I want best for my family",
    tagline: "Medication dispensers, monitors, nebulizers & everyday care devices",
    tone: "warm",
  },
];

const hospitalVisitProducts = [
  {
    id: 501,
    name: "Electric Hospital Bed",
    subtitle: "Full Electric Adjustable",
    category: "premium",
    visitCategory: "hospital",
    subCategory: "electric-hospital-bed",
    tag: "SPECIALIST",
    description: "Full-electric adjustable hospital bed for home recovery. Four-motor positioning, safety side rails, and lockable caster wheels for safe hospital-to-home care.",
    features: [
      "4-motor electric height & incline adjustment",
      "Full-length safety side rails",
      "Lockable medical-grade caster wheels",
      "Foot-pedal & side panel controls",
      "Trendelenburg & reverse positioning",
      "Hospital-to-home recovery ready",
    ],
    color: "#f8fafc",
    accent: "#5b9bd5",
    image: electricHospitalBedImg,
  },
  {
    id: 502,
    name: "Manual Transport Wheelchair",
    subtitle: "Lightweight Foldable",
    category: "mobility",
    visitCategory: "hospital",
    subCategory: "manual-wheelchair",
    tag: "MOBILITY",
    description: "Lightweight aluminum transport wheelchair for caregivers and daily mobility. Foldable frame, padded mesh seating, and hand brakes for safe, comfortable transfers.",
    features: [
      "Foldable aluminum frame",
      "Padded mesh seat & backrest",
      "Flip-up armrests",
      "Caregiver hand brakes",
      "Integrated seatbelt",
    ],
    color: "#e8e8e8",
    accent: "#6b7280",
    image: manualWheelchairImg,
  },
  {
    id: 503,
    name: "Shower Commode Chair",
    subtitle: "Mobile Toilet & Shower Seat",
    category: "mobility",
    visitCategory: "hospital",
    subCategory: "shower-commode",
    tag: "SAFETY",
    description: "Water-resistant aluminum commode and shower chair in one. Removable bucket, padded armrests, and swivel wheels for safe bedside and bathroom use.",
    features: [
      "Shower-safe aluminum frame",
      "Removable commode bucket",
      "Padded armrests",
      "Height-adjustable legs",
      "Swivel caster wheels",
    ],
    color: "#f5f5f5",
    accent: "#5b8a72",
    image: showerCommodeImg,
  },
  {
    id: 507,
    name: "Vital Monitoring Kit",
    subtitle: "Complete home monitoring set",
    category: "monitoring",
    visitCategory: "hospital",
    isKit: true,
    tag: "SET",
    description:
      "One complete vital monitoring set for hospital-to-home recovery. Includes CGM, BP monitor, and pulse oximeter — everything needed to track recovery at home.",
    features: [
      "CGM continuous glucose monitor",
      "Upper arm digital BP monitor",
      "Fingertip pulse oximeter",
      "Complete set — order as one kit",
      "Hospital-to-home recovery ready",
    ],
    kitItems: [
      {
        id: 508,
        name: "Pulse Oximeter",
        subtitle: "Fingertip SpO2 Monitor",
        category: "monitoring",
        tag: "ESSENTIAL",
        description:
          "Clip-on fingertip pulse oximeter for instant SpO2 and pulse rate readings. Bright LED display with one-button operation for home and travel monitoring.",
        features: [
          "SpO2 & pulse rate (BPM) display",
          "Bright red LED readout",
          "One-button fingertip operation",
          "Low battery indicator",
          "Portable clip-on design",
          "Auto power-off",
        ],
        color: "#f0f4f8",
        accent: "#2563eb",
        image: pulseOximeterImg,
      },
      {
        id: 509,
        name: "BP Monitor",
        subtitle: "Upper Arm Digital",
        category: "monitoring",
        tag: "ESSENTIAL",
        description:
          "Hospital-grade upper arm blood pressure monitor for home use. Large LCD display, WHO classification bar, and memory for daily tracking.",
        features: [
          "Large LCD display",
          "WHO classification indicator",
          "Pulse rate measurement",
          "22–32 cm arm cuff",
          "Memory for 2 users",
        ],
        color: "#f8f8f8",
        accent: "#3d6b58",
        image: bpMonitorImg,
      },
      {
        id: 510,
        name: "CGM",
        subtitle: "Continuous Glucose Monitor",
        category: "premium",
        tag: "NEW",
        description:
          "Wearable continuous glucose monitoring with Bluetooth sync to your smartphone. Real-time interstitial fluid readings, trend analytics, and hypo/hyper alerts without routine finger pricks.",
        features: [
          "Real-time interstitial glucose monitoring",
          "Bluetooth Low Energy (BLE) smartphone sync",
          "14-day extended-wear waterproof sensor",
          "Time-in-range & glycemic trend analytics",
          "One-click automated sensor applicator",
          "Customizable hypo/hyperglycemic alerts",
        ],
        color: "#f5f5f5",
        accent: "#2d8b7a",
        image: cgmSystemImg,
      },
    ],
    color: "#f0f7f4",
    accent: "#1f4d3d",
  },
];

const familyVisitProducts = [
  {
    id: 601,
    name: "Medication Dispenser",
    subtitle: "Automatic Electronic Pill Organizer",
    category: "premium",
    visitCategory: "family",
    subCategory: "medication-dispenser",
    tag: "ESSENTIAL",
    description:
      "Automatic electronic medication dispenser with 28 rotating compartments and a central LCD schedule display. Sounds an alarm at dose time and dispenses the right pills — ideal for families managing complex daily medication routines.",
    features: [
      "28-compartment rotating pill organizer",
      "Central LCD with time & alarm display",
      "Scheduled dose reminders",
      "One-touch OPEN dispensing latch",
      "Battery-powered portable design",
      "Ideal for elderly & chronic care at home",
    ],
    color: "#f8fafc",
    accent: "#2563eb",
    image: medicationDispenserImg,
  },
  {
    id: 607,
    name: "CGM",
    subtitle: "Continuous Glucose Monitor",
    category: "premium",
    visitCategory: "family",
    subCategory: "cgm",
    tag: "NEW",
    description:
      "Wearable continuous glucose monitoring with Bluetooth sync to your smartphone. Real-time interstitial fluid readings, trend analytics, and hypo/hyper alerts without routine finger pricks.",
    features: [
      "Real-time interstitial glucose monitoring",
      "Bluetooth Low Energy (BLE) smartphone sync",
      "14-day extended-wear waterproof sensor",
      "Time-in-range & glycemic trend analytics",
      "One-click automated sensor applicator",
      "Customizable hypo/hyperglycemic alerts",
    ],
    color: "#f5f5f5",
    accent: "#2d8b7a",
    image: cgmSystemImg,
  },
  {
    id: 602,
    name: "Digital Thermometer",
    subtitle: "Non-Contact Infrared",
    category: "monitoring",
    visitCategory: "family",
    subCategory: "digital-thermometer",
    tag: "ESSENTIAL",
    description:
      "Non-contact infrared thermometer for hygienic body temperature checks. Green backlit LCD with memory recall and fever alarm indicators.",
    features: [
      "Non-contact infrared sensor",
      "Instant digital readout",
      "Green backlit LCD display",
      "Body & object temperature modes",
      "Memory recall function",
      "Mute mode for quiet use",
    ],
    color: "#ffffff",
    accent: "#16a34a",
    image: digitalThermometerImg,
  },
  {
    id: 603,
    name: "BP Monitor",
    subtitle: "Upper Arm Digital",
    category: "monitoring",
    visitCategory: "family",
    subCategory: "bp-monitor",
    tag: "ESSENTIAL",
    description:
      "Hospital-grade upper arm blood pressure monitor for home use. Large LCD display, WHO classification bar, and memory for daily tracking.",
    features: [
      "Large LCD display",
      "WHO classification indicator",
      "Pulse rate measurement",
      "22–32 cm arm cuff",
      "Memory for 2 users",
    ],
    color: "#f8f8f8",
    accent: "#3d6b58",
    image: bpMonitorImg,
  },
  {
    id: 604,
    name: "Mesh Nebulizer",
    subtitle: "Handheld Portable",
    category: "monitoring",
    visitCategory: "family",
    subCategory: "mesh-nebulizer",
    tag: "ESSENTIAL",
    description:
      "Ultra-portable mesh nebulizer with intelligent LED interface. Vibrating mesh atomization delivers fine particles for effective respiratory therapy at home.",
    features: [
      "Vibrating mesh atomization",
      "Handheld portable design",
      "LED timer & status display",
      "Low-liquid & battery alerts",
      "Silent operation technology",
      "Includes face mask attachment",
    ],
    color: "#f5f5f5",
    accent: "#64748b",
    image: meshNebulizerImg,
  },
  {
    id: 605,
    name: "Pulse Oximeter",
    subtitle: "Fingertip SpO2 Monitor",
    category: "monitoring",
    visitCategory: "family",
    subCategory: "pulse-oximeter",
    tag: "ESSENTIAL",
    description:
      "Clip-on fingertip pulse oximeter for instant SpO2 and pulse rate readings. Bright LED display with one-button operation for home and travel monitoring.",
    features: [
      "SpO2 & pulse rate (BPM) display",
      "Bright red LED readout",
      "One-button fingertip operation",
      "Low battery indicator",
      "Portable clip-on design",
      "Auto power-off",
    ],
    color: "#f0f4f8",
    accent: "#2563eb",
    image: pulseOximeterImg,
  },
  {
    id: 606,
    name: "Glucometer",
    subtitle: "Digital Blood Glucose Meter",
    category: "monitoring",
    visitCategory: "family",
    subCategory: "glucometer",
    tag: "ESSENTIAL",
    description:
      "Compact digital blood glucose meter for precise at-home testing. Large high-contrast LCD, rapid micro-sample technology, and onboard memory for daily glucose tracking.",
    features: [
      "Large high-contrast LCD display",
      "Rapid result technology (seconds)",
      "Micro-sample blood requirement",
      "Internal memory for trend review",
      "Automatic test strip recognition",
      "One-touch M-button operation",
    ],
    color: "#ffffff",
    accent: "#4a6fa5",
    image: glucometerImg,
  },
];


export function getKitItems(product) {
  if (!product?.isKit) return [];
  return product.kitItems ?? [];
}

export const products = [
  {
    id: 1,
    name: "Electric Wheelchair",
    subtitle: "Pro Series",
    category: "premium",
    tag: "BESTSELLER",
    description: "Precision-engineered electric mobility for independence and dignity. Whisper-quiet motor, ergonomic seating, long-range battery.",
    features: ["12-hour battery life", "Foldable frame", "Smart joystick control", "USB charging port"],
    color: "#f5f5f5",
    accent: "#1f4d3d",
    image: electricWheelchairImg,
  },
  {
    id: 2,
    name: "CGM System",
    subtitle: "Continuous Glucose Monitor",
    category: "premium",
    tag: "NEW",
    description: "Real-time glucose tracking with 14-day sensor life. Discreet wearable that syncs to your smartphone.",
    features: ["14-day wear", "Bluetooth sync", "Alert system", "No finger pricks"],
    color: "#f5f5f5",
    accent: "#2d8b7a",
    image: cgmSystemImg,
  },
  {
    id: 3,
    name: "Smart Hearing Aid",
    subtitle: "Audiophile Edition",
    category: "premium",
    tag: "PREMIUM",
    description: "AI-powered sound processing with Bluetooth streaming. Virtually invisible, exceptionally powerful.",
    features: ["AI noise cancellation", "Bluetooth 5.0", "Rechargeable", "App controlled"],
    color: "#f5f5f5",
    accent: "#1f4d3d",
    image: bluetoothHearingAidImg,
  },
  {
    id: 4,
    name: "CPAP Machine",
    subtitle: "Sleep Apnea Therapy",
    category: "premium",
    tag: "CLINICAL",
    description: "Advanced sleep therapy for obstructive sleep apnea. Auto-adjusting pressure with humidification.",
    features: ["Auto pressure", "Heated humidifier", "Sleep data tracking", "Travel-ready"],
    color: "#f8fafc",
    accent: "#66c0f4",
    image: cpapMachineImg,
  },
  {
    id: 5,
    name: "Electric Hospital Bed",
    subtitle: "Alzheimer Patient Series",
    category: "premium",
    tag: "SPECIALIST",
    description: "Full-electric adjustable bed with safety rails, designed for Alzheimer patients. Fall prevention and caregiver alerts.",
    features: ["4-motor adjustment", "Safety rail system", "Pressure relief mattress", "Nurse call button"],
    color: "#f8fafc",
    accent: "#5b9bd5",
    image: electricHospitalBedImg,
  },
  {
    id: 6,
    name: "Tranquil GPS Watch",
    subtitle: "Dementia Care — AngelSense",
    category: "premium",
    tag: "CARE+",
    description: "GPS tracking wristband with fall detection for Alzheimer patients. Two-way calling, geo-fence alerts.",
    features: ["Real-time GPS", "Fall detection", "Geo-fence alert", "Two-way calling"],
    color: "#2d1b69",
    accent: "#e040fb",
    imageType: "watch",
  },
  {
    id: 7,
    name: "Standard Hearing Aid",
    subtitle: "Essential Series",
    category: "midrange",
    tag: "VALUE",
    description: "Reliable hearing amplification for everyday use. Comfortable behind-the-ear design.",
    features: ["Digital processing", "4 listening programs", "Telecoil", "IP68 waterproof"],
    color: "#1a1a1a",
    accent: "#4a5568",
    image: neckbandHearingAidImg,
  },
  {
    id: 8,
    name: "BP Monitor",
    subtitle: "Clinical Accuracy",
    category: "monitoring",
    tag: "ESSENTIAL",
    description: "Hospital-grade blood pressure monitoring for home use. Large display, irregular heartbeat detection.",
    features: ["WHO classification", "Memory for 2 users", "Irregular beat alert", "AC/battery"],
    color: "#f8f8f8",
    accent: "#3d6b58",
    image: bpMonitorImg,
  },
  {
    id: 9,
    name: "Nebulizer",
    subtitle: "Mesh Technology",
    category: "monitoring",
    tag: "ESSENTIAL",
    description: "Silent mesh nebulizer for respiratory therapy. Fine particle size for deep lung delivery.",
    features: ["Silent operation", "Fine mesh", "Portable", "USB powered"],
    color: "#f5f5f5",
    accent: "#64748b",
    image: meshNebulizerImg,
  },
  {
    id: 10,
    name: "Rollator Walker",
    subtitle: "Foldable Comfort",
    category: "mobility",
    tag: "MOBILITY",
    description: "Lightweight aluminum rollator with built-in seat. Folds flat for transport, ergonomic hand brakes.",
    features: ["Built-in seat", "Foldable", "Ergonomic brakes", "Storage pouch"],
    color: "#ffffff",
    accent: "#78716c",
    image: walkingCaneImg,
  },
  {
    id: 11,
    name: "Shower Chair",
    subtitle: "Safety Combo Set",
    category: "mobility",
    tag: "SAFETY",
    description: "Complete shower safety set: adjustable chair with non-slip mat and grab bar combo.",
    features: ["Non-slip mat included", "Grab bar combo", "Adjustable height", "300kg load rated"],
    color: "#f5f5f5",
    accent: "#5b8a72",
    image: showerCommodeImg,
  },
  {
    id: 12,
    name: "CareCort",
    subtitle: "Blue Edition",
    category: "monitoring",
    tag: "FEATURED",
    description: "Multi-parameter home health monitoring device. Track vitals from a single elegant device.",
    features: ["SpO2 monitoring", "ECG capable", "Temperature", "Cloud sync"],
    color: "#f0f4f8",
    accent: "#2563eb",
    image: pulseOximeterImg,
  },
];

function catalogNeedProduct(id) {
  const product = products.find((p) => p.id === id);
  return product ? { ...product } : null;
}

export const needProducts = {
  elderly: elderlyNeedProducts,
  diabetes: diabetesNeedProducts,
  hearing: hearingNeedProducts,
  homecare: homecareNeedProducts,
};

export const visitProducts = {
  hospital: hospitalVisitProducts,
  family: familyVisitProducts,
};

export const team = [
  {
    name: "Dr. Astha Ghimire",
    role: "MBBS · Clinical Dietician",
    image: drAsthaGhimireImg,
    whatsapp: "9779843608172",
    shortBio:
      "MBBS-qualified physician and clinical dietician guiding preventive care, nutrition, and healthy-habit planning.",
    bio: "Dr. Astha Ghimire is an MBBS-qualified physician and clinical dietician focused on preventive, evidence-based care. She integrates clinical medicine with medical nutrition therapy to design individualized plans for chronic-disease management, metabolic and lifestyle conditions, and everyday wellness. From selecting the right home monitoring devices to structuring balanced diets and sustainable healthy habits, she provides patient-centered guidance grounded in general health, clinical nutrition, and long-term well-being.",
    contact: "WhatsApp consultation available",
    expertise: [
      "General Health & Preventive Care",
      "Clinical Nutrition & Dietetics",
      "Healthy Habits & Lifestyle",
    ],
  },
  {
    name: "Er. Ashok Paudel",
    role: "Biomedical Engineer",
    image: erAshokPaudelImg,
    whatsapp: "9779822484987",
    shortBio:
      "Biomedical engineer specializing in device selection, installation, and technical support for medical equipment.",
    bio: "Er. Ashok Paudel is a biomedical engineer specializing in medical device technology, installation, and lifecycle support. He advises on selecting the right equipment for each clinical and home-care need, ensures safe and correct setup, and handles calibration, preventive maintenance, and troubleshooting. His engineering expertise bridges advanced medical technology with reliable, hassle-free operation — so every device performs safely and dependably in real-world use.",
    contact: "Email & WhatsApp",
    expertise: [
      "Biomedical Equipment & Devices",
      "Installation & Calibration",
      "Maintenance & Technical Support",
    ],
  },
];
